import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiActivity, FiSettings, FiEye } = FiIcons;

const VehicleCard = ({ vehicle }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    }).format(price);
  };

  const formatKilometers = (km) => {
    return new Intl.NumberFormat('es-ES').format(km) + ' km';
  };

  // Función para desplazar al principio de la página
  const handleViewDetails = (e) => {
    // Desplazamos al principio de la ventana
    window.scrollTo(0, 0);
  };

  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
    >
      <div className="relative">
        <img
          src={vehicle.images[0] || 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=400&h=250&fit=crop'}
          alt={`${vehicle.brand} ${vehicle.model}`}
          className="w-full h-48 object-cover"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-[#e67e22] text-white px-3 py-1 rounded-full text-sm font-semibold">
            {vehicle.year}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="bg-[#27ae60] text-white px-3 py-1 rounded-full text-sm font-semibold">
            {formatPrice(vehicle.price)}
          </span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-[#2c3e50] mb-2">
          {vehicle.brand} {vehicle.model}
        </h3>
        <p className="text-gray-600 mb-4">{vehicle.version}</p>
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiCalendar} className="w-4 h-4 text-[#7f8c8d]" />
            <span className="text-sm text-gray-600">{vehicle.year}</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiActivity} className="w-4 h-4 text-[#7f8c8d]" />
            <span className="text-sm text-gray-600">{formatKilometers(vehicle.kilometers)}</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiSettings} className="w-4 h-4 text-[#7f8c8d]" />
            <span className="text-sm text-gray-600">{vehicle.fuel}</span>
          </div>
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiSettings} className="w-4 h-4 text-[#7f8c8d]" />
            <span className="text-sm text-gray-600">{vehicle.transmission}</span>
          </div>
        </div>
        <Link
          to={`/vehiculo/${vehicle.id}`}
          onClick={handleViewDetails}
          className="w-full bg-[#005c91] hover:bg-[#3498db] text-white py-3 px-4 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2"
        >
          <SafeIcon icon={FiEye} className="w-5 h-5" />
          <span>Ver Detalles</span>
        </Link>
      </div>
    </motion.div>
  );
};

export default VehicleCard;